import * as React from "react";
import AnimateHeight from "react-animate-height";
import classNames from "classnames";

export interface IAccordionItemProps {
    isActive?: boolean;
    className?: string;
    renderHeader: React.ReactNode;
    renderContent?: React.ReactNode;
    duration?: number;
}

const AccordionItem: React.FC<IAccordionItemProps> = props => {
    const baseRootClass = "accordion-item";
    const rootClasses = classNames(baseRootClass, props.className, {
        [`${baseRootClass}--isExpanded`]: props.isActive
    });

    return (
        <div className={rootClasses}>
            {props.renderHeader}
            {props.renderContent && (
                <AnimateHeight
                    className="accordion-rah-content"
                    contentClassName="accordion-content-wrapper"
                    duration={props.duration || 300}
                    applyInlineTransitions={false}
                    height={props.isActive ? "auto" : 0}
                >
                    {props.renderContent}
                </AnimateHeight>
            )}
        </div>
    );
};

export default AccordionItem;
